import { useEffect } from 'react';
import { Spinner } from '@postenbring/hedwig-react';
import './edi-scheduler.scss';

export const EdiScheduler = ({ salesforceBaseUrl, language }) => {
    /**
     * Initialize Lightning when loaded
     */
    useEffect(() => {
        const initializeLightning = () => {
            if (!window.$Lightning || !salesforceBaseUrl) return;

            window.$Lightning.use(
                'runtime_appointmentbooking:lightningOutGuest',
                function () {
                    window.$Lightning.createComponent(
                        'lightning:flow',
                        {},
                        'lexcontainerEDI',
                        function (component) {
                            component.startFlow(
                                'EDIInbound_New_Guest_Appointment_2',
                                [
                                    { name: 'language', type: 'String', value: language },
                                    { name: 'currentUrl', type: 'String', value: document.referrer }
                                ]
                            );
                        }
                    );
                },
                `${salesforceBaseUrl}/EDI`
            );
        };

        if (window.$Lightning) {
            initializeLightning();
            return;
        }

        window.addEventListener('lightningLoaded', initializeLightning);

        return () => window.removeEventListener('lightningLoaded', initializeLightning);
    }, []);

    return (
        <div className="edi-scheduler-wrapper">
            <div id="spinner-container">
                <Spinner size="large" />
            </div>
            <div id="lexcontainerEDI"></div>
        </div>
    );
}

